import { I as t } from "../../constants-DeVuDy8J.js";
import { createElementBlock as d, openBlock as l, normalizeClass as n, createElementVNode as r } from "vue";
import { _ as o } from "../../_plugin-vue_export-helper-CHgC5LLL.js";
const c = {
  name: "DtIconThread",
  props: {
    /**
     * The size of the icon.
     * @values 100, 200, 300, 400, 500, 600, 700, 800
     */
    size: {
      type: String,
      default: "500",
      validator: (e) => Object.keys(t).includes(e)
    },
    /**
     * The label of the icon as read out by a screenreader. Leave this unset if your icon is purely presentational
     */
    ariaLabel: {
      type: String,
      default: void 0
    }
  },
  /**
  * @TODO: Remove this emit once the icons migration is complete,
  * they will no longer need this event.
  * */
  emits: ["loaded"],
  computed: {
    iconSizeClass() {
      return t[this.size];
    },
    ariaHidden() {
      return this.ariaLabel ? "false" : "true";
    },
    dataQA() {
      return this.$attrs["data-qa"] ?? "dt-icon";
    }
  },
  created() {
    this.$emit("loaded");
  }
}, s = ["aria-label", "data-qa", "aria-hidden"], _ = /* @__PURE__ */ r("path", {
  fill: "currentColor",
  "fill-rule": "evenodd",
  d: "M2.833 3.837a.5.5 0 0 1 .5-.5h5.334a.5.5 0 1 1 0 1H3.333a.5.5 0 0 1-.5-.5Zm0 1.667a.5.5 0 0 1 .5-.5h3.334a.5.5 0 0 1 0 1H3.333a.5.5 0 0 1-.5-.5Zm0 1.666a.5.5 0 0 1 .5-.5h1.334a.5.5 0 0 1 0 1H3.333a.5.5 0 0 1-.5-.5Z",
  "clip-rule": "evenodd"
}, null, -1), h = /* @__PURE__ */ r("path", {
  fill: "currentColor",
  d: "M2.394 2.522c-.162.03-.296.087-.374.165-.077.077-.134.211-.164.374-.014.074-.02.142-.022.19v4.417a.52.52 0 0 1-.001.021v.062c.003.047.008.114.022.188.03.16.086.295.165.374.08.08.214.136.374.166.074.013.141.019.189.02.023.002.04.002.051.002l.033-.001H8.46L7.313 7.354a.5.5 0 1 1 .707-.708l2 2a.5.5 0 0 1 0 .708l-2 2a.5.5 0 0 1-.707-.707L8.46 9.5H2.541a2.37 2.37 0 0 1-.328-.037c-.249-.046-.614-.156-.9-.442-.286-.286-.396-.651-.442-.9a2.371 2.371 0 0 1-.038-.461V3.307c0-.025 0-.06.002-.102.004-.083.014-.197.038-.327.046-.248.156-.614.44-.898.285-.285.65-.395.898-.44a2.404 2.404 0 0 1 .43-.04.51.51 0 0 1 .026 0h6.667a1.572 1.572 0 0 1 .133.003c.083.004.197.015.327.04.245.046.611.155.893.437.281.281.39.648.437.893a2.494 2.494 0 0 1 .043.46V6a.5.5 0 0 1-1 0V3.317v.002-.01c0-.012 0-.03-.002-.055a1.473 1.473 0 0 0-.023-.195c-.032-.166-.09-.3-.162-.372-.073-.073-.206-.13-.373-.162a1.492 1.492 0 0 0-.249-.025h-.01.001-6.765a1.405 1.405 0 0 0-.19.022Z"
}, null, -1), m = [
  _,
  h
];
function u(e, f, i, p, v, a) {
  return l(), d("svg", {
    "aria-label": i.ariaLabel,
    class: n([a.iconSizeClass, "d-icon d-icon--thread"]),
    "data-qa": a.dataQA,
    "aria-hidden": a.ariaHidden,
    role: "img",
    "data-name": "Thread",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 12 12"
  }, m, 10, s);
}
const C = /* @__PURE__ */ o(c, [["render", u]]);
export {
  C as default
};
//# sourceMappingURL=thread.js.map
